import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { reduxForm, Field, SubmissionError, reset } from 'redux-form';

import Spinner from 'components/Spinner';
import InputField from 'components/InputField';
import FormError from 'components/FormError';
import { setSimoWifiSettings } from 'api';
import { fetchSimoDeviceDiagnostic } from 'actions/simoDiagnostic';
import ChangeVsimModal from 'components/modals/ChangeVsimModal';

class ConfirmRestartDeviceModal extends Component {
  render() {
    const { isOpen, onClose, onSubmit } = this.props;

    const handleSubmit = () => {
      onClose();
      onSubmit();
    };

    return (
      <ReactModal
        appElement={document.getElementById('root')}
        isOpen={isOpen}
        portalClassName="AdjustmentCreditPortal"
        overlayClassName="AdjustmentCreditModal__Overlay"
        className="AdjustmentCreditModal__Content restart-device-modal"
      >
        <div className="modal-header">
          <span className="close" onClick={onClose}>
            &times;
          </span>
          <h2>Restart Device</h2>
        </div>
        <div className="modal-body">
          <p>Are you sure to restart this device's modem?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-default mar-r"
            onClick={onClose}
          >
            Cancel
          </button>
          <button className="mar-l btn btn-primary" onClick={handleSubmit}>
            Restart
          </button>
        </div>
      </ReactModal>
    );
  }
}

class WifiSettingsModal extends Component {
  render() {
    const { error, wifiLoading, isOpen, onClose, handleSubmit } = this.props;

    return (
      <ReactModal
        appElement={document.getElementById('root')}
        isOpen={isOpen}
        portalClassName="AdjustmentCreditPortal"
        overlayClassName="AdjustmentCreditModal__Overlay"
        className="AdjustmentCreditModal__Content wifi-setting-modal"
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-header">
            <span className="close" onClick={onClose}>
              &times;
            </span>
            <h2>Wi-Fi Settings</h2>
          </div>
          <div className="modal-body">
            <Spinner showLoader={wifiLoading} />
            <Field component={InputField} name="wifi_ssid" label="Wi-Fi Name" />
            <Field
              component={InputField}
              name="wifi_password"
              label="Wi-Fi Password"
            />
            {error && <FormError error={error} />}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default mar-r"
              onClick={onClose}
            >
              Cancel
            </button>
            <button className="mar-l btn btn-primary">Submit</button>
          </div>
        </form>
      </ReactModal>
    );
  }
}

WifiSettingsModal = reduxForm({
  form: 'wifiSettingsModalForm',
  validate: (values) => {
    let errors = {};

    if (!values.wifi_ssid) {
      errors.wifi_ssid = 'Required';
    }

    if (!values.wifi_password) {
      errors.wifi_password = 'Required';
    }

    return errors;
  },
  enableReinitialize: true,
})(WifiSettingsModal);

class DiagnosticActions extends Component {
  state = {
    isOpenWifiModal: false,
    isOpenVsimChangeModal: false,
    isOpenConfirmRestartDeviceModal: false,
    wifiLoading: false,
  };

  openWifiModal = () => this.setState({ isOpenWifiModal: true });
  closeWifiModal = () => {
    this.setState({ isOpenWifiModal: false });
    this.props.resetForm('wifiSettingsModalForm');
  };

  openVsimChangeModal = () => this.setState({ isOpenVsimChangeModal: true });
  closeVsimChangeModal = () => this.setState({ isOpenVsimChangeModal: false });

  openConfirmRestartDeviceModal = () =>
    this.setState({ isOpenConfirmRestartDeviceModal: true });
  closeConfirmRestartDeviceModal = () =>
    this.setState({ isOpenConfirmRestartDeviceModal: false });

  changeWifiSettings = (values) => {
    const { simoDeviceId, fetchSimoDeviceDiagnostic } = this.props;
    this.setState({ wifiLoading: true });
    return setSimoWifiSettings(simoDeviceId, values)
      .then((res) => {
        return fetchSimoDeviceDiagnostic(simoDeviceId);
      })
      .then(() => {
        this.setState({ wifiLoading: false, isOpenWifiModal: false });
        this.props.resetForm('wifiSettingsModalForm');
      })
      .catch((err) => {
        let messages = err.response
          ? err.response.data
          : { detail: 'Something went wrong' };
        this.setState({ wifiLoading: false });
        if (messages.detail || messages.error) {
          throw new SubmissionError({ _error: messages });
        } else {
          throw new SubmissionError(messages);
        }
      });
  };

  render() {
    const {
      restartConnection,
      sendSignalScan,
      restartDevice,
      diagnostic,
      simoDeviceId,
    } = this.props;
    const {
      isOpenWifiModal,
      isOpenConfirmRestartDeviceModal,
      isOpenVsimChangeModal,
      wifiLoading,
    } = this.state;

    return (
      <div className="simo-diagnostic-row">
        <button
          className="btn btn-default"
          onClick={this.openConfirmRestartDeviceModal}
        >
          Restart Device
        </button>
        <button className="btn btn-default mar-l" onClick={restartConnection}>
          Restart Connection
        </button>
        <button className="btn btn-default mar-l" onClick={this.openWifiModal}>
          WiFi Settings
        </button>
        <button
          className="btn btn-default mar-l"
          onClick={this.openVsimChangeModal}
        >
          Change vSIM
        </button>
        <button className="btn btn-default mar-l" onClick={sendSignalScan}>
          Signal Scan
        </button>
        <WifiSettingsModal
          isOpen={isOpenWifiModal}
          onClose={this.closeWifiModal}
          onSubmit={this.changeWifiSettings}
          wifiLoading={wifiLoading}
          initialValues={{
            wifi_ssid: diagnostic?.wifi_ssid,
            wifi_password: diagnostic?.wifi_password,
          }}
        />
        <ConfirmRestartDeviceModal
          isOpen={isOpenConfirmRestartDeviceModal}
          onClose={this.closeConfirmRestartDeviceModal}
          onSubmit={restartDevice}
        />
        <ChangeVsimModal
          simoDeviceId={simoDeviceId}
          isOpen={isOpenVsimChangeModal}
          closeModal={this.closeVsimChangeModal}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {};

const mapDispathToProps = {
  fetchSimoDeviceDiagnostic,
  resetForm: reset,
};

export default connect(mapStateToProps, mapDispathToProps)(DiagnosticActions);
